import ToggleSelectFieldComponent from './toggle-select-field-component';

/***
 * similar to SelectField, except that it also includes a checkbox next to the field's label which allows you to
 * enable and disable the dropdown field.
 */
const toggleSelectField = angular
    .module('FacilityData.ClientEdit.FormFields.ToggleSelectField', [])
    .component('toggleSelectField', ToggleSelectFieldComponent)
    .name;

export default toggleSelectField;


// WEBPACK FOOTER //
// ./app/common/form-fields/toggle-select-field/toggle-select-field.js